// The stop whose detail panel is expanded: other pages can deep-link to a stop (e.g. from the product grid), and
// going back to the stop page (e.g. from the layout editor) restores the expanded stop - the stop page pages to it,
// expands its detail panel and scrolls to it.
export const validateStopSearch = (search: Record<string, unknown>) => {
  const stopId = Number(search.stopId);

  return {
    ...(search.stopId != null && !Number.isNaN(stopId) && { stopId }),
  };
};
